import { DefaultApi } from '../../../api';
import { getCatchError } from '../../../getCatchError';
import { urls } from '../../../urls';

const setPostBlock = (params) => {
    return async (dispatch, getState) => {
        try {
            await DefaultApi({
                params,
                method: 'post',
                url: urls.POST_BLOCK_CASHIERS
            });

        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setPostBlock as SetPostBlock
}